import { ContractRole } from '@paid-ui/enums/contract';
import { AgentIcon } from '@paid-ui/icons/agent';
import { BrushIcon } from '@paid-ui/icons/brush';
import { DeliveryTruckIcon } from '@paid-ui/icons/delivery-truck';
import { DeveloperIcon } from '@paid-ui/icons/developer';
import { FunderIcon } from '@paid-ui/icons/funder';
import { HelmetIcon } from '@paid-ui/icons/helmet';
import { OwnerKeyIcon } from '@paid-ui/icons/owner-key';
import { QSIcon } from '@paid-ui/icons/qs';
import { ArchitectIcon } from '@paid-ui/icons/sketch';
import { UserIcon } from '@paid-ui/icons/user';

export const contractRoleIconMap = {
  [ContractRole.PRINCIPAL]: OwnerKeyIcon,
  [ContractRole.CONTRACTOR]: HelmetIcon,
  [ContractRole.BUILDER]: HelmetIcon,
  [ContractRole.SUBCONTRACTOR]: BrushIcon,
  [ContractRole.SUPPLIER]: DeliveryTruckIcon,
  [ContractRole.ARCHITECT]: ArchitectIcon,
  [ContractRole.SUPERINTENDENT]: AgentIcon,
  [ContractRole.QUANTITY_SURVEYOR]: QSIcon,
  [ContractRole.OFFEREE]: FunderIcon,
  [ContractRole.OFFEROR]: DeveloperIcon,
  [ContractRole.SPONSOR]: FunderIcon,
  [ContractRole.PAYER_AGENT]: FunderIcon,
  '': UserIcon,
} as Record<ContractRole | '', React.FC<React.SVGProps<SVGSVGElement>>>;
